// F8 milestones — governed by UI plan §2.2: caloly celebrates the ACT OF
// TRACKING and nothing else.
//
// The feature plan also listed "first kilo" as a milestone. That is
// deliberately NOT implemented: §2.2 forbids celebrating weight-loss velocity,
// and a body-weight milestone is exactly that. Someone whose weight stalls
// while they log faithfully every day should still be congratulated; someone
// who drops a kilo in a bad week should not be cheered on. Days logged is the
// behaviour we actually want to reinforce, and it's the one the user controls.

export interface Milestone {
  /** Days-logged threshold that unlocks it. */
  days: number;
  /** Locale key for the headline. */
  key: string;
}

export const MILESTONES: Milestone[] = [
  { days: 1, key: "milestone.first_log" },
  { days: 7, key: "milestone.week" },
  { days: 30, key: "milestone.month" },
  { days: 100, key: "milestone.hundred" },
  { days: 365, key: "milestone.year" },
];

/** The highest milestone reached at this many logged days, or null. */
export function milestoneFor(loggedDays: number): Milestone | null {
  let hit: Milestone | null = null;
  for (const m of MILESTONES) {
    if (loggedDays >= m.days) hit = m;
  }
  return hit;
}

/** The next milestone to aim at, or null once every one is reached. */
export function nextMilestone(loggedDays: number): Milestone | null {
  return MILESTONES.find((m) => m.days > loggedDays) ?? null;
}
